import { Spin } from 'antd';
import { Declaration } from 'store/declarations/declaration';
import MirroredDeclarationRow from './MirroredDeclarationRow';
import { PopoverBody, PopoverMessage } from './styles';

type Props = {
    declarations: Declaration[];
    isLoading: boolean;
    hasError: boolean;
    manifestId?: string;
    jobId?: string;
};

const MirroredDeclarationsPopoverContent = ({ declarations, isLoading, hasError, manifestId, jobId }: Props) => {
    if (isLoading) {
        return (
            <PopoverBody>
                <PopoverMessage>
                    <Spin size="small" />
                    Loading linked declarations...
                </PopoverMessage>
            </PopoverBody>
        );
    }

    if (hasError) {
        return (
            <PopoverBody>
                <PopoverMessage>Could not load the linked declarations.</PopoverMessage>
            </PopoverBody>
        );
    }

    if (declarations.length === 0) {
        return (
            <PopoverBody>
                <PopoverMessage>No linked declarations found.</PopoverMessage>
            </PopoverBody>
        );
    }

    return (
        <PopoverBody data-testid="mirrored-declarations-popover-list">
            {declarations.map((declaration) => (
                <MirroredDeclarationRow
                    key={declaration.id}
                    declaration={declaration}
                    manifestId={manifestId}
                    jobId={jobId}
                />
            ))}
        </PopoverBody>
    );
};

export default MirroredDeclarationsPopoverContent;
